import { createApi } from "@reduxjs/toolkit/query/react";
import { prepareBaseQuery } from "./baseQueryWithReauth";

const emailsApi = createApi({
  reducerPath: "send-emails",
  baseQuery: prepareBaseQuery("/send-email/"),
  tagTypes: ["SendEmails"],
  endpoints: (builder) => ({
    sendBookEventEmail: builder.mutation({
      query: ({ sendData }) => ({
        url: "book-event",
        method: "POST",
        body: { sendData },
      }),
    }),
    sendEventEmailWithAttachments: builder.mutation({
      query: ({
        clientEmail,
        clientName,
        includeInvoice,
        includeDeposit,
        includeVoidCheque,
        customBodyText,
        eventId,
        toEmails,
        askForTable,
      }) => ({
        url: "send-event-email",
        method: "POST",
        body: {
          clientEmail,
          clientName,
          includeInvoice,
          includeDeposit,
          includeVoidCheque,
          customBodyText,
          eventId,
          ...(Array.isArray(toEmails) && toEmails.length ? { toEmails } : {}),
          ...(typeof askForTable === "boolean" ? { askForTable } : {}),
        },
      }),
    }),
    sendCustomEmail: builder.mutation({
      query: ({
        eventId,
        subject,
        bodyHtml,
        templateKey,
        toEmails,
        attachments,
        attachmentIds,
        stateChanges,
        askForTable,
      }) => ({
        url: "send-custom",
        method: "POST",
        body: {
          eventId,
          subject,
          bodyHtml,
          ...(templateKey ? { templateKey } : {}),
          ...(Array.isArray(toEmails) && toEmails.length ? { toEmails } : {}),
          ...(attachments ? { attachments } : {}),
          ...(Array.isArray(attachmentIds) && attachmentIds.length
            ? { attachmentIds }
            : {}),
          ...(stateChanges ? { stateChanges } : {}),
          ...(typeof askForTable === "boolean" ? { askForTable } : {}),
        },
      }),
    }),
    renderTemplate: builder.mutation({
      query: ({
        eventId,
        templateKey,
        blocks,
        attachedFileNames,
        depositEmailMode,
        askForTable,
        includeAddress,
      }) => ({
        url: "render-template",
        method: "POST",
        body: {
          eventId,
          templateKey,
          ...(blocks ? { blocks } : {}),
          ...(Array.isArray(attachedFileNames) && attachedFileNames.length
            ? { attachedFileNames }
            : {}),
          ...(depositEmailMode ? { depositEmailMode } : {}),
          ...(typeof askForTable === "boolean" ? { askForTable } : {}),
          // Street address in the legal footer: sent only when ticked.
          ...(includeAddress === true ? { includeAddress: true } : {}),
        },
      }),
    }),
    // POST /send-email/preview-custom (djr-be, JWT): the subject and body
    // send-custom would send for this text (placeholders filled, the
    // askForTable line, dashes cleaned). Read only: sends and saves nothing.
    previewCustomEmail: builder.mutation({
      query: ({ eventId, subject, bodyHtml, askForTable }) => ({
        url: "preview-custom",
        method: "POST",
        body: {
          eventId,
          subject: subject ?? "",
          bodyHtml: bodyHtml ?? "",
          ...(typeof askForTable === "boolean" ? { askForTable } : {}),
        },
      }),
    }),
    listBlocks: builder.query({
      query: () => ({ url: "blocks", method: "GET" }),
    }),
    getEventAttachmentAvailability: builder.query({
      query: (eventId) => ({
        url: `event/${eventId}/attachment-availability`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useSendBookEventEmailMutation,
  useSendEventEmailWithAttachmentsMutation,
  useSendCustomEmailMutation,
  useRenderTemplateMutation,
  usePreviewCustomEmailMutation,
  useListBlocksQuery,
  useGetEventAttachmentAvailabilityQuery,
} = emailsApi;

export default emailsApi;
